import { ArrowDownward, Reply, ThumbUpOffAlt } from "@mui/icons-material";
import { Button, Paper, Tooltip, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import ShareModal from "./ShareModal";
import { tokens } from "../../store/tokens";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: tokens.color.surface,
  borderRadius: `${tokens.radius.lg}px`,
  boxShadow: 24,
  p: 4,
};

const actionButtonSx = {
  paddingX: 2,
  height: tokens.button.height.sm,
  color: tokens.color.ink,
  bgcolor: tokens.color.surfaceMuted,
  fontSize: tokens.button.fontSize.sm,
  fontWeight: 600,
  textTransform: "none",
  borderRadius: `${tokens.radius.pill}px`,
  "&:hover": {
    bgcolor: tokens.color.tealLight,
    color: tokens.color.tealDark,
  },
};

const FloatingInfo = (props) => {
  const { profileDetails, handleGeneratePdf } = props;
  const { cinfo } = profileDetails;

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Profile data (and the PDF snapshot it feeds) loads asynchronously, so
  // the button used to be clickable before there was anything to export —
  // clicking early produced a mostly-blank PDF. Disable it until we
  // actually have a name to show, and tell the ref is real before calling
  // it so a slow mount can't throw.
  const profileReady = Boolean(profileDetails?.cname);

  const handleDownloadClick = () => {
    if (!profileReady) return;
    handleGeneratePdf?.();
  };

  return (
    <Paper
      elevation={0}
      sx={{
        padding: { xs: 3, md: `${tokens.card.padding.md}px` },
        position: "relative",
      }}
    >
      <Typography
        variant="body1"
        sx={{ color: tokens.color.ink, fontWeight: 500 }}
      >
        {cinfo}
      </Typography>

      <Stack
        spacing={1.25}
        direction={"row"}
        justifyContent="left"
        alignItems={"center"}
        sx={{ marginTop: 1.5, flexWrap: "wrap" }}
      >
        <Button startIcon={<ThumbUpOffAlt />} size="small" sx={actionButtonSx}>
          Follow
        </Button>

        <Button
          startIcon={<Reply sx={{ transform: "scaleX(-1)" }} />}
          size="small"
          sx={actionButtonSx}
          onClick={handleOpen}
        >
          Share
        </Button>

        <Tooltip title={profileReady ? "" : "Still loading this profile…"}>
          <span>
            <Button
              startIcon={<ArrowDownward />}
              size="small"
              disabled={!profileReady}
              sx={{
                ...actionButtonSx,
                "&.Mui-disabled": {
                  color: tokens.color.inkFaint,
                  bgcolor: tokens.color.surfaceMuted,
                },
              }}
              onClick={handleDownloadClick}
            >
              Download
            </Button>
          </span>
        </Tooltip>
      </Stack>

      <ShareModal
        handleClose={handleClose}
        open={open}
        profileDetails={profileDetails}
        style={modalStyle}
      />
    </Paper>
  );
};

export default FloatingInfo;
